<template>
  <div>
    <div class="modal" v-show="modalShown">
      <div class="modal-main">
        <div class="title-area">
          <h2>カスタムカラー設定</h2>
        </div>
        <div class="input-area">
          <ul>
            <li v-for="(color, index) in colorList" :key="index">
                <input type="radio" :id="color.colorId" :value="color.colorId" v-model="colorId">
                <label :for="color.colorId">
                  <img class="color-tex" :src="getImg(color)" alt="color-tex"/>
                </label>
            </li>
          </ul>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="onOk">OK</button>
          <button type="button" class="main_btn" @click="onClear">クリア</button>
          <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'

export default {
  name: 'CustomColorListModal',
  props: {
    /** ファイルデータ */
    fileData: Object
  },
  data () {
    return {
      /** モーダルの表示フラグ */
      modalShown: false,
      /** デフォルトのカラー設定であるかの判定値 */
      isColorStyleDefault: false,
      /** カラーマテリアルID */
      colorMaterialId: null,
      /** カラーマテリアルのリスト */
      colorMaterialList: [],
      /** カラースタイルグループのindex番号 */
      colorStyleGrpNum: 0,
      /** カラー画像ID */
      colorId: null,
      /** カラー画像リスト */
      colorList: []
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function (colorMaterialId, colorId, colorMaterialList, isColorStyleDefault, colorStyleGrpNum) {
      this.isColorStyleDefault = isColorStyleDefault
      this.colorMaterialId = colorMaterialId
      this.colorMaterialList = colorMaterialList
      this.colorStyleGrpNum = colorStyleGrpNum
      this.colorList = this.fileData.colorMasterList
        .filter(color => color.colorCustomIndex != null)
        .sort((a, b) => a.colorCustomIndex - b.colorCustomIndex)
      this.colorId = colorId
      this.modalShown = true
    },
    getImg: function (colorMaster) {
      let colorMaterial = this.colorMaterialList.find(c => c.colorMaterialId === this.colorMaterialId)
      // 表面材がある場合は表面材
      let surfaceMaterialMaster = this.fileData.materialMasterList
        .find(material => material.materialId === colorMaterial.colorMaterialSurface)
      if (surfaceMaterialMaster != null) {
        return this.requireImgPath(colorMaster, surfaceMaterialMaster)
      }
      // 表面材が無かったら芯材
      let boardMaterialMaster = this.fileData.materialMasterList
        .find(material => material.materialId === colorMaterial.colorMaterialBoard)
      return this.requireImgPath(colorMaster, boardMaterialMaster)
    },
    requireImgPath: function (colorMaster, materialMaster) {
      if (colorMaster) {
        if (materialMaster.materialGrainDir === 2 && colorMaster.colorDispTexHName) {
          // 横木目
          return this.getImage('tex/' + colorMaster.colorDispTexHName)
        } else {
          // 木目なしもしくは縦目
          return this.getImage('tex/' + colorMaster.colorDispTexVName)
        }
      }
      return this.getImage('noimage.svg')
    },
    onOk: function () {
      /** モーダル非表示 */
      this.modalShown = false
      if (this.isColorStyleDefault) {
        this.$emit('changeColorIdDefault', this.colorId)
      } else {
        this.$emit('changeColorIdGrp', this.colorId, this.colorStyleGrpNum)
      }
    },
    onClear: function () {
      this.colorId = null
    },
    onCancel: function () {
      this.modalShown = false
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal .modal-main {
  max-width: 765px;
  min-width: 765px;
  max-height: 70%;
  .input-area {
    padding: 10px 10px 10px 10px;
    min-height: 300px;
    margin: 20px auto;
    max-height: 403px;
    overflow-y: auto;
    ul {
      margin-left: 32px;
      li {
        width: 210px;
        margin-left: 5px;
        margin-right: 5px;
        display: inline-block;
        .color-tex {
          width: 100px;
          height: 100px;
          margin: 6px;
          padding: 0px;
          border: thin solid #000000;
        }
        input[type="radio"]:checked + label img{
          background: #FF4500;
          margin: 3px;
          padding: 3px;
        }
        input[type=radio] {
          display: none;
        }
        // input[type=radio]+label:before {
        //   content: "";
        //   display: inline-block;
        //   background-size: contain;
        //   width: 140px;
        //   height: 140px;
        // }
        // input[type=radio]:checked+label::before {
        //   border: 3px solid #000;
        //   box-sizing: border-box;
        // }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/CustomColorListModal.vue